export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export interface Review {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export interface ContactInfo {
  type: string;
  icon: string;
  value: string;
  label: string;
}

export const milestones: Milestone[] = [
  { year: '2018', title: '网站创立', description: '韩漫网正式上线，致力于为中文读者提供优质的韩国漫画内容，初始团队仅5人。' },
  { year: '2019', title: '内容扩充', description: '漫画数量突破500部，与韩国多家漫画平台达成内容合作，日活用户突破10万。' },
  { year: '2020', title: '技术升级', description: '全面升级阅读体验，推出下拉式阅读模式，支持高清漫画图片加载，移动端适配完成。' },
  { year: '2021', title: '迅猛增长', description: '漫画库扩充至2000部以上，月活用户突破100万，成为华语地区最大的韩漫阅读平台。' },
  { year: '2022', title: '品牌升级', description: '全新品牌形象上线，推出会员体系与社区功能，用户互动体验全面提升。' },
  { year: '2023', title: '国际化布局', description: '开拓东南亚市场，多语言版本陆续上线，全球注册用户突破500万。' },
  { year: '2024', title: '新里程碑', description: '漫画总量突破5000部，合作画师超过200位，原创漫画业务正式启动。' },
];

export const reviews: Review[] = [
  {
    id: 'r1',
    name: '小猫咪爱看漫',
    avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20avatar%20portrait%2C%20simple%20clean%20design%2C%20pink%20hair%2C%20big%20eyes%2C%20kawaii%20style%2C%20soft%20pastel%20colors&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '真的超级推荐韩漫网！画质高清，更新速度超快，而且完全免费！下拉式的阅读体验太舒服了，一口气看了几十话根本停不下来。分类也很详细，找漫画非常方便。',
    date: '2026-07-28',
  },
  {
    id: 'r2',
    name: '追漫达人Leo',
    avatar: 'https://readdy.ai/api/search-image?query=cool%20anime%20style%20boy%20avatar%20portrait%2C%20simple%20clean%20design%2C%20dark%20hair%2C%20sharp%20eyes%2C%20modern%20style%2C%20neutral%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为追了五年韩漫的老读者，韩漫网是我用过最好的平台。漫画资源非常全，很多冷门韩漫都能找到。网站稳定不卡顿，加载速度很快，强烈推荐！',
    date: '2026-07-25',
  },
  {
    id: 'r3',
    name: '夜雨听风',
    avatar: 'https://readdy.ai/api/search-image?query=elegant%20anime%20style%20woman%20avatar%20portrait%2C%20simple%20design%2C%20long%20black%20hair%2C%20gentle%20expression%2C%20soft%20lighting%2C%20clean%20background&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '网站整体使用体验不错，漫画种类很丰富。下拉式阅读确实比翻页舒服很多。希望后续能增加评论功能和收藏同步功能，这样就完美了！',
    date: '2026-07-20',
  },
  {
    id: 'r4',
    name: '漫画控小杰',
    avatar: 'https://readdy.ai/api/search-image?query=young%20anime%20style%20boy%20avatar%20portrait%2C%20simple%20design%2C%20brown%20hair%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20background&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '朋友推荐过来的，真的发现宝藏了！终于不用到处找韩漫资源了。最近迷上了异界魔法师，更新超快，每天都有新章节看，太幸福了！',
    date: '2026-07-18',
  },
];

export const contactInfo: ContactInfo[] = [
  { type: 'email', icon: 'ri-mail-line', value: 'contact@hanmanwang.com', label: '联系邮箱' },
  { type: 'wechat', icon: 'ri-wechat-line', value: 'hanmanwang_official', label: '微信公众号' },
  { type: 'weibo', icon: 'ri-weibo-line', value: '@韩漫网官方', label: '微博账号' },
  { type: 'qq', icon: 'ri-qq-line', value: '800123456', label: 'QQ客服' },
];